import { Injectable } from '@angular/core';
import { calculateClaimAmount, exportToCsv, exportToCsvWithColor, exportToExcel, formatDuration, getBrokersList, isDecimal } from 'src/app/utils/utils.common';
import * as moment from 'moment-timezone';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { CamelCasePipe } from 'src/app/pipe/camelcase.filter/camelcase.filter.pipe';

@Injectable({
  providedIn: 'root'
})
export class CsvService {

  constructor(
    private driverService: DriversService,
    private capitalize: CamelCasePipe

  ) { }



  generateDriverReport(data) {
    const { date, trips, corporate, driver, vehicle, timezone } = data;

    const myTrips = JSON.parse(JSON.stringify(trips));

    const table = [
      [
        "Driver",
        "Account Code",
        "Auth Num",
        "Schedule Time",
        "Appointment Time",
        "Will Call",
        "LOA",
        "Passenger's Phone #",
        "Passenger's First Name",
        "Passenger's Last Name",
        "Pickup Name",
        "PU Phone #",
        "PU Address",
        "Dropoff Name",
        "Dropoff Phone #",
        "Dropoff Address",
        "Rider Comments",
      ]];

    let privatePay = myTrips.filter(trip => {
      if (corporate) {
        if (trip.jobType !== 'cooperate') {
          return false;
        }
        if (trip.cooperate && trip.cooperate._id.toString() !== corporate) {
          return false;
        }
      }
      if (driver) {
        if (trip.driver && trip.driver._id.toString() !== driver) {
          return false;
        }
      }
      if (vehicle) {
        if (trip.tripRequirement !== vehicle) {
          return false;
        }
      }
      return true;
    })

    const driverWise = {};
    for (const trip of privatePay) {
      if (trip.driver) {
        if (trip.driver && driverWise[trip.driver.displayName]) {
          driverWise[trip.driver.displayName].push(trip);
        } else {
          driverWise[trip.driver.displayName] = [trip];
        }
      } else {
        if (driverWise["unassigned"]) {
          driverWise["unassigned"].push(trip);
        } else {
          driverWise["unassigned"] = [trip];
        }
      }

    }


    var sortedObject = {};
    var sortedKeys = Object.keys(driverWise).sort();
    for (var key of sortedKeys) {
      sortedObject[key] = driverWise[key];
    }

    for (const driverId in sortedObject) {
      for (const trip of driverWise[driverId]) {

        let forTrip;
        if (trip.jobType !== 'cooperate') {
          forTrip = trip.companyType === "" ? "Cab Dispatch" : getBrokersList[trip.companyType];
        }

        if (trip.jobType === 'cooperate') {
          forTrip = trip.cooperate ? trip.cooperate.displayName : "N/A"
        }

        let appointmentTime;
        if (trip.appointmentTime) {
          appointmentTime = moment(trip.appointmentTime).tz(timezone).format('MM/DD/YYYY HHmm');
        }
        let scheduleTime;
        if (trip.scheduleTime) {
          scheduleTime = moment(trip.scheduleTime).tz(timezone).format('MM/DD/YYYY HHmm');
        }
        let name = trip.priorityClient.displayName.split(' ');


        const t = [
          trip.driver ? trip.driver.displayName : '',
          forTrip,
          trip.tripId,
          scheduleTime,
          appointmentTime,
          scheduleTime.split(" ")[1] >= "22" ? "Y" : "N",
          this.checkCarType(trip.tripRequirement),
          trip.priorityClient.contactNumber,
          name[0], //"Passenger's First Name",
          name[1] ? name[1] : '', //"Passenger's Last Name",
          trip.originAddressAdditional && trip.originAddressAdditional.place ? trip.originAddressAdditional.place : '',
          trip.originAddressAdditional && trip.originAddressAdditional.phone ? trip.originAddressAdditional.phone : '',
          trip.jobOriginAddress, //"Passenger's Address",,
          trip.destinationAddressAdditional && trip.destinationAddressAdditional.place ? trip.destinationAddressAdditional.place : '',
          trip.destinationAddressAdditional && trip.destinationAddressAdditional.phone ? trip.destinationAddressAdditional.phone : '',
          trip.jobDestinationAddress, //"Passenger's Address",
          trip.note,
        ]
        table.push(t);
      }
    }


    exportToCsv(`drivers-manifest-${date}.csv`, table);
    // this.excelService.setCombinedFirstRowWithFontSize(date, table, `drivers-report-${moment().format("MM-DD-YYYY")}`);
  }

  checkCarType(car) {
    const vehicles = {
      'BW': 'SUV',
      'SUV': 'SUV',
      'Premium': 'P',
      'Stretcher': 'GUR',
      'S': 'GUR',
      'BLS': 'GUR',
      'BSTR': 'GUR',
      'VS': 'GUR',
      'LIV': 'A',
      'AMB': 'A',
      'Ambulatory': 'A',
      'Wheelchair': 'WC',
      'W': 'WC',
      'WAV': 'WC',
      'WPCA': 'WC',
      'WMAV': 'WC',
      'A': 'A',
      'L': 'A',
      'ADD': 'A',
      'AMAV': 'A',
      'Standard': 'A',
      '': 'A'
    };

    if (!vehicles[car]) return car;
    return vehicles[car];
  }
  generateCorporateReport(data) {
    const { trips, corporate, driver, vehicle, payor, timezone } = data;

    const table = [[
      "Passenger's First Name",
      "Passenger's Last Name",
      "Passenger DOB",
      "Schedule Time",
      "Appointment Time",
      "Gender",
      "Weight",
      "Passenger's Phone #",
      "Passenger's 2-nd Phone#",
      "Passenger's Address",
      "Email	On Hold (Y/N)",
      "Corporate Name",
      "Payor",
      "Active Payer (Y/N)"
    ]];

    let filterdataList = trips.filter(trip => {

      if (corporate) {
        if (trip.jobType !== 'cooperate') {
          return false;
        }
        if (trip.cooperate && trip.cooperate._id.toString() !== corporate) {
          return false;
        }

      }

      if (payor) {
        if (!trip.payor || trip.payor.toLowerCase() !== payor.toLowerCase()) {
          return false;
        }
      }

      if (driver) {
        if (trip.driver && trip.driver._id.toString() !== driver) {
          return false;
        }
      }

      if (vehicle) {
        if (trip.tripRequirement !== vehicle) {
          return false;
        }
      }
      return true;
    })


    for (const trip of filterdataList) {

      let forTrip;
      if (trip.jobType === 'cooperate') {
        forTrip = trip.cooperate ? trip.cooperate.displayName : "N/A"
      }

      let appointmentTime;
      if (trip.appointmentTime) {
        appointmentTime = moment(trip.appointmentTime).tz(timezone).format('MM/DD/YYYY HHmm');
      }
      let scheduleTime;
      if (trip.scheduleTime) {
        scheduleTime = moment(trip.scheduleTime).tz(timezone).format('MM/DD/YYYY HHmm');
      }
      let name = trip.priorityClient.displayName.split(' ');
      const t = [
        name[0], //"Passenger's First Name",
        name[1] ? name[1] : 'N/A', //"Passenger's Last Name",
        trip.dob, //"Passenger DOB",
        scheduleTime,
        appointmentTime,
        "---", //"Gender",
        trip.weight, //"Weight",
        trip.priorityClient.cellPhone, //"Passenger's Phone #",
        trip.priorityClient.contactNumber, //"Passenger's 2-nd Phone#",
        trip.jobOriginAddress, //"Passenger's Address",
        trip.priorityClient.email, //"Email	On Hold (Y/N)",
        forTrip, //"Payer",
        trip.payor, //"Payor",
        "TRUE", //"Active Payer (Y/N)",
      ]
      table.push(t);
    }
    exportToCsv(`payor-report-${moment().format("MM-DD-YYYY")}.csv`, table);
  }

  generateScoreReport(data) {
    const { date, scores } = data;
    const table = [
      [
        "Driver",
        "Completed",
        "Early",
        "On Time",
        "Late",
        "Early Time Score",
        "On Time Score",
        "Late Time Score"
      ]];

    scores.forEach(score => {
      table.push([
        score.driver.displayName,
        score.total,
        score.earlyTrips,
        score.onTimeTrips,
        score.lateTrips,
        isDecimal(score.percentageEarly) ? score.percentageEarly.toFixed(2) + '%' : score.percentageEarly + '%',
        isDecimal(score.percentageOnTime) ? score.percentageOnTime.toFixed(2) + '%' : score.percentageOnTime + '%',
        isDecimal(score.percentageLate) ? score.percentageLate.toFixed(2) + '%' : score.percentageLate + '%'
      ]);
    });
    exportToCsv(`driver-score-${date}.csv`, table);
  }




  async multiSheet(data, dateRange, driver,timeZone, loader) {
    if (data && driver && dateRange) {
      const table1 = [
        [
          'Date Range',
          'Driver Name',
          'Total Working Hours',
          'Total Break Hours',
          'Total Days',
        ]
      ]

      let t = [
        moment(dateRange.startDate).format("MM/DD/YYYY") + '-' + moment(dateRange.endDate).format("MM/DD/YYYY"),
        driver.displayName,
        this.viewHourFormat(data.workTimeInMillis),
        this.viewHourFormat(data.breakTimeInMillis),
        data.totalDays,
      ]
      table1.push(t)


      const table2 = [
        [
          "Date",
          "Driver Name",
          "Employee Id",
          "Rig No",
          "Vin",
          "Pull Out",
          "Pull In",
          "Meal Break Out",
          "Meal Break In",
          "Meal Break Out 2",
          "Meal Break In 2",
          "Rest Break Out",
          "Rest Break In",
          "Pull Out (Actual)",
          "Pull In (Actual)",
          "Break Hours",
          "Working Hours",
        ]
      ]
      if (data.jobs && data.jobs.length) {
        for (const item of data.jobs) {
          const driverBreaks = item
          let mealBreakOut, mealBreakIn, mealBreakOut2, mealBreakIn2, restBreakOut, restBreakIn;
          let totalBreakTime = 0;

         if (driverBreaks.breaks && driverBreaks.breaks.length) {

              let isFirstBreak = false;
              driverBreaks.breaks.forEach(breakItem => {
                if (breakItem.status === "rest") {
                  restBreakOut = breakItem.start;
                  restBreakIn  = breakItem.stop;
                }

                if (breakItem.status === "approved") {
                  if (isFirstBreak) {
                    mealBreakOut2 = breakItem.start;
                    mealBreakIn2 = breakItem.stop;
                  } else {
                    isFirstBreak = true;
                    mealBreakOut = breakItem.start;
                    mealBreakIn = breakItem.stop;
                  }
                }

                if (breakItem.duration) {
                  totalBreakTime += breakItem.duration;
                }
              });
          }

          let workingTime = 0;
          if (driverBreaks.checkin && driverBreaks.checkout) {
            const checkinTime = moment(driverBreaks.checkin).valueOf();
            const checkoutTime = moment(driverBreaks.checkout).valueOf();
            workingTime = checkoutTime - checkinTime - totalBreakTime;
          }
          const tableData = [
            moment(item.checkin).tz(timeZone).format("MM/DD/YYYY"),
            driver ? driver.displayName : "N/A",
            driver ? driver.employeeId : "N/A",
            driver.fleet && driver.fleet.setiDecall ? driver.fleet.setiDecall : "N/A",
            driver.fleet && driver.fleet.vin ? driver.fleet.vin : "N/A",
            driverBreaks.shift && driverBreaks.shift.checkin ? driverBreaks.shift.checkin : "N/A",
            driverBreaks.shift &&  driverBreaks.shift.checkout ? driverBreaks.shift.checkout : "N/A",
            mealBreakOut ? moment(mealBreakOut).tz(timeZone).format("HH:mm") : "N/A",
            mealBreakIn ? moment(mealBreakIn).tz(timeZone).format("HH:mm") : "N/A",
            mealBreakOut2 ? moment(mealBreakOut2).tz(timeZone).format("HH:mm") : "N/A",
            mealBreakIn2  ? moment(mealBreakIn2).tz(timeZone).format("HH:mm") : "N/A",
            restBreakOut ? moment(restBreakOut).tz(timeZone).format("HH:mm") : "N/A",
            restBreakIn ? moment(restBreakIn).tz(timeZone).format("HH:mm") : "N/A",
            driverBreaks.checkin ? moment(driverBreaks.checkin).tz(timeZone).format("HH:mm") : "N/A",
            driverBreaks.checkout ? moment(driverBreaks.checkout).tz(timeZone).format("HH:mm") : "N/A",
            this.viewHourFormat(totalBreakTime),
            this.viewHourFormat(workingTime),
          ];

          table2.push(tableData);
        }
      }

      const sheets = {
        "timesheet": table1,
        "history": table2,
      };
      exportToExcel(`${driver.displayName}-history-${moment(dateRange.startDate).format("MM-DD") + '-to-' + moment(dateRange.endDate).format("MM-DD-YYYY")}.xlsx`, sheets);
      loader.isLoading = false;
    }
  }


  generateTripItineraryReport(trips, date, timezone, preCooperates, preLevelOfServices, preSpaceTypes, preServiceAreas, preFleet) {
    const table = [
      [
        "trip_id",
        "trip_status",
        "created_at",
        "service_area",
        "pu_address",
        "pu_date",
        "do_address",
        "do_date",
        "actual_miles",
        "funding_source",
        "source",
        "track_id",
        "los",
        "space_type",
        "ipa_number",
        "passenger_name",
        "phone_number",
        "cell_phone",
        "client_id",
        "insurance_id",
        "dob",
        "weight",
        "driver_name",
        "Rig No",
        "odometer_begin",
        "odometer_start",
        "odometer_end",
        "dead_miles",
        "dead_minutes",
        "wait_time",
        "trip_miles",
        "trip_time",
        "total_trip_miles",
        "total_trip_time",
        "total_trip_miles_+_dead_miles",
        "total_trip_time_+_dead_minutes",
        "driver_notes",
        "biller_notes",
        "dispatcher_notes",
        "accepted_time",
        "accepted_coords",
        "onscene_time",
        "onscene_coords",
        "started_time",
        "started_coords",
        "ended_time",
        "ended_coords",
        "finished_time",
        "finished_coords",
        "BSR",
        "change_reason"
      ]];
    trips.forEach(trip => {
      let acceptedDate, pickupDate, arrivedDate, endDate, finishDate, scheduleTime, appointmentTime, createdAt = ' ';
      if (trip.scheduleTime) {
        scheduleTime = moment(trip.scheduleTime).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.createdAt) {
        createdAt = moment(trip.createdAt).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.appointmentTime) {
        appointmentTime = moment(trip.appointmentTime).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.job) {
        if (trip.job.trackInfoJob) {
          if (trip.job.trackInfoJob.jobAccepted) {
            if (trip.job.trackInfoJob.jobAccepted.time) {
              acceptedDate = moment(trip.job.trackInfoJob.jobAccepted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobArrived) {
            if (trip.job.trackInfoJob.jobArrived.time) {
              pickupDate = moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobStarted) {
            if (trip.job.trackInfoJob.jobStarted.time) {
              arrivedDate = moment(trip.job.trackInfoJob.jobStarted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobCompleted) {
            if (trip.job.trackInfoJob.jobCompleted.time) {
              endDate = moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }

          if (trip.job.trackInfoJob.jobFinished) {
            if (trip.job.trackInfoJob.jobFinished.time) {
              finishDate = moment(trip.job.trackInfoJob.jobFinished.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }

        }

      }



      let data = [
        trip.tripId ? trip.tripId : ' ',
        trip.status ? trip.status : ' ',
        createdAt ? createdAt : ' ',
        preServiceAreas[trip.serviceArea] ? preServiceAreas[trip.serviceArea].name : ' ',
        trip.jobOriginAddress ? trip.jobOriginAddress : ' ',
        scheduleTime ? scheduleTime : ' ',
        trip.jobDestinationAddress ? trip.jobDestinationAddress : ' ',
        appointmentTime ? appointmentTime : ' ',
        trip.milage ? trip.milage : ' ',
        preCooperates[trip.cooperate] ? preCooperates[trip.cooperate].displayName : ' ',
        trip.rawId ? "Parsed" : "Manual",
        trip.trackId ? trip.trackId : ' ',
        preLevelOfServices && preLevelOfServices[trip.los] ? preLevelOfServices[trip.los].title : ' ',
        preSpaceTypes && preSpaceTypes[trip.spaceType] ? preSpaceTypes[trip.spaceType].title : ' ',
        trip.ipa ? trip.ipa : ' ',
        trip.priorityClient && trip.priorityClient.displayName ? trip.priorityClient.displayName : ' ',
        trip.priorityClient && trip.priorityClient.contactNumber ? trip.priorityClient.contactNumber : ' ',
        trip.priorityClient && trip.priorityClient.cellPhone ? trip.priorityClient.cellPhone : ' ',
        trip.priorityClient && trip.priorityClient.clientId ? trip.priorityClient.clientId : ' ',
        trip.priorityClient && trip.priorityClient.memberId ? trip.priorityClient.memberId : ' ',
        trip.dob ? trip.dob : ' ',
        trip.weight ? trip.weight : ' ',
        trip.driver ? trip.driver.displayName : ' ',
        trip.driver && trip.driver.fleet && preFleet && preFleet[trip.driver.fleet] ? preFleet[trip.driver.fleet].setiDecall : ' ',
        trip.job ? trip.job.odometerBegin : ' ',
        trip.job ? trip.job.odometerStart : ' ',
        trip.job ? trip.job.odometerStop : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMiles ? trip.job.additionalInfoJob.surchargeMiles : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMinutes ? trip.job.additionalInfoJob.surchargeMinutes : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobWaitTime ? trip.job.additionalInfoJob.jobWaitTime : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.totalMiles ? trip.job.additionalInfoJob.totalMiles : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobMinutes ? trip.job.additionalInfoJob.jobMinutes : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobTotalMiles ? trip.job.additionalInfoJob.jobTotalMiles.toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobTotalTime ? trip.job.additionalInfoJob.jobTotalTime.toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMiles && trip.job.additionalInfoJob.jobTotalMiles ? (trip.job.additionalInfoJob.jobTotalMiles + trip.job.additionalInfoJob.surchargeMiles).toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMinutes && trip.job.additionalInfoJob.jobTotalTime ? (trip.job.additionalInfoJob.jobTotalTime + trip.job.additionalInfoJob.surchargeMinutes).toFixed(2) : ' ',
        trip.companyNote ? trip.companyNote : ' ',
        trip.billerNote ? trip.billerNote : ' ',
        trip.dispatchNoteTwo ? trip.dispatchNoteTwo : ' ',
        acceptedDate ? acceptedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobAccepted && trip.job.trackInfoJob.jobAccepted.time ? [trip.job.trackInfoJob.jobAccepted.coords[0], trip.job.trackInfoJob.jobAccepted.coords[1]].toString() : ' ',
        pickupDate ? pickupDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobArrived && trip.job.trackInfoJob.jobArrived.time ? [trip.job.trackInfoJob.jobArrived.coords[0], trip.job.trackInfoJob.jobArrived.coords[1]].toString() : ' ',
        arrivedDate ? arrivedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobStarted && trip.job.trackInfoJob.jobStarted.time ? [trip.job.trackInfoJob.jobStarted.coords[0], trip.job.trackInfoJob.jobStarted.coords[1]].toString() : ' ',
        endDate ? endDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobCompleted && trip.job.trackInfoJob.jobCompleted.time ? [trip.job.trackInfoJob.jobCompleted.coords[0], trip.job.trackInfoJob.jobCompleted.coords[1]].toString() : ' ',
        finishDate ? finishDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobFinished && trip.job.trackInfoJob.jobFinished.time ? [trip.job.trackInfoJob.jobFinished.coords[0], trip.job.trackInfoJob.jobFinished.coords[1]].toString() : " ",
        trip.preSpecialRate ? trip.preSpecialRate : ' ',
        trip.changeReason ? trip.changeReason : ' ',
      ]
      table.push(data)
    });

    exportToCsv(`reports-${moment(date[0]).tz(timezone).format("MM-DD-YYYY")}-${moment(date[1]).tz(timezone).format("MM-DD-YYYY")}.csv`, table);
  }

  generateRawTripReport(trips, date, timezone, preCooperates, preLevelOfServices, preSpaceTypes, preServiceAreas, preFleet, preDrivers, prePayorsList) {
    const table = [
      [
        "trip_id",
        "trip_id (Modified)",
        "trip_status",
        "trip_status (Modified)",
        "payment_status",
        "change_reason",
        "cancellation_time",
        "will_call",
        "will_call_activation_time",

        "passenger_name",
        "Mobile Number",
        "phone_number",
        "client_id",
        "dob",
        "weight",

        "pu_address",
        "pu_address (Modified)",
        "pu_date",
        "pu_date (Modified)",

        "pu_city",
        "pu_city (Modified)",

        "pu_state",
        "pu_state (Modified)",

        "pu_zip",
        "pu_zip (Modified)",

        "do_address",
        "do_address (Modified)",
        "do_date",
        "do_date (Modified)",

        "do_city",
        "do_city (Modified)",

        "do_state",
        "do_state (Modified)",

        "do_zip",
        "do_zip (Modified)",

        "trip_miles",
        "trip_miles (Modified)",

        "funding_source",
        "funding_source (Modified)",

        "payor",

        "driver_name",
        "driver_name (Modified)",

        // Cost Center
        "cost_center",

        "fleet",
        "fleet (Modified)",

        "spacetype",
        "spacetype (Modified)",

        "ipa_number",
        "ipa_number (Modified)",

        "payment_mode",
        "coupon_id",

        "authorization_number",
        "authorization_number (Modified)",

        "accepted_time",
        "accepted_time (Modified)",
        "accepted_coords",
        "onscene_time",
        "onscene_time (Modified)",
        "onscene_coords",
        "started_time",
        "started_time (Modified)",
        "started_coords",
        "ended_time",
        "ended_time (Modified)",
        "ended_coords",
        "finished_time",
        "finished_time (Modified)",
        "finished_coords",

        // fare
        "total_fare",
        "total_fare (Modified)",
        "final_fare",
        "paid_amount",
        "paid_status",

        "base_fare",
        "base_fare (Modified)",
        "base_fare_code",
        "base_fare_code (Modified)",
        "per_mile",
        "per_mile (Modified)",
        "per_mile_code",
        "per_mile_code (Modified)",

        "pu_modifier",
        "pu_modifier (Modified)",
        "do_modifier",
        "do_modifier (Modified)",
        "primary_diagnose",
        "primary_diagnose (Modified)",

        "odometer_begin",
        "odometer_begin (Modified)",
        "odometer_start",
        "odometer_start (Modified)",
        "odometer_end",
        "odometer_end (Modified)",

        "track_id",
        "raw_id",
        "created_at",

        "driver_notes",
        "biller_notes",
        "dispatcher_notes",

        "service_area",
        "level_of_service",


        "dead_miles",
        "dead_minutes",
        "wait_time",
        "trip_miles",
        "trip_time",
        "total_trip_miles",
        "total_trip_time",
        "total_trip_miles_+_dead_miles",
        "total_trip_time_+_dead_minutes",
        "Addon Fare",
        "Modified Addon Fare",
        "Ontime Initiated(Yes/No)",
        "Appointment Type(s)",
        "Appointment Time",
        "Cancellation Notes",
        "signature_url",
        "created_by",
        "updated_by"
      ]];
    trips.forEach(trip => {
      let totalAddonFare = 0;
      if (trip.addonServices && trip.addonServices.length) {
        totalAddonFare = trip.addonServices.reduce((sum, addon) => sum + addon.total, 0)
      }
      const adjustedTrip = trip.adjustmentjob ? trip.adjustmentjob : undefined;

      let adjustmentAddonFare = 0;
      if (adjustedTrip && adjustedTrip.addonServices && adjustedTrip.addonServices.length) {
        adjustmentAddonFare = adjustedTrip.addonServices.reduce((sum, addon) => sum + parseFloat(addon.total), 0)
      }

      let totalClaims = 0;

      if (adjustedTrip && adjustedTrip.claims && adjustedTrip.claims.length) {
        totalClaims = adjustedTrip.claims.reduce((sum, claim) => sum + parseFloat(claim.claim), 0);
      }

      let acceptedDate, arrivedDate, startedDate, completedDate, cancelledDate, finishedDate = ' ';
      let adjustedAcceptedDate, adjustedArrivedDate, adjustedStartedDate, adjustedCompletedDate, adjustedFinishedDate;
      let isBeforeScheduleTime = false;
      if (trip.job) {
        if (trip.job.trackInfoJob) {
          if (trip.job.trackInfoJob.jobAccepted) {
            if (trip.job.trackInfoJob.jobAccepted.time) {
              acceptedDate = moment(trip.job.trackInfoJob.jobAccepted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
            if (trip.job.trackInfoJob.jobAccepted.time) {
              isBeforeScheduleTime = moment(trip.job.trackInfoJob.jobAccepted.time).tz(timezone).isBefore(moment(trip.scheduleTime).tz(timezone));
          }
          }
          if (trip.job.trackInfoJob.jobArrived) {
            if (trip.job.trackInfoJob.jobArrived.time) {
              arrivedDate = moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobStarted) {
            if (trip.job.trackInfoJob.jobStarted.time) {
              startedDate = moment(trip.job.trackInfoJob.jobStarted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobCompleted) {
            if (trip.job.trackInfoJob.jobCompleted.time) {
              completedDate = moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobFinished) {
            if (trip.job.trackInfoJob.jobFinished.time) {
              finishedDate = moment(trip.job.trackInfoJob.jobFinished.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobCancelled) {
            if (trip.job.trackInfoJob.jobCancelled.time) {
              cancelledDate = moment(trip.job.trackInfoJob.jobCancelled.time)
                .tz(timezone)
                .format("MMM DD, YYYY : HH:mm");
            }
          }

        }
      }

      if (adjustedTrip && adjustedTrip.trackInfoJob) {
        if (adjustedTrip.trackInfoJob.jobAccepted) {
          if (adjustedTrip.trackInfoJob.jobAccepted.time) {
            adjustedAcceptedDate = moment(adjustedTrip.trackInfoJob.jobAccepted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
          }
        }
        if (adjustedTrip.trackInfoJob.jobArrived) {
          if (adjustedTrip.trackInfoJob.jobArrived.time) {
            adjustedArrivedDate = moment(adjustedTrip.trackInfoJob.jobArrived.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
          }
        }
        if (adjustedTrip.trackInfoJob.jobStarted) {
          if (adjustedTrip.trackInfoJob.jobStarted.time) {
            adjustedStartedDate = moment(adjustedTrip.trackInfoJob.jobStarted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
          }
        }
        if (adjustedTrip.trackInfoJob.jobCompleted) {
          if (adjustedTrip.trackInfoJob.jobCompleted.time) {
            adjustedCompletedDate = moment(adjustedTrip.trackInfoJob.jobCompleted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
          }
        }
        if (adjustedTrip.trackInfoJob.jobFinished) {
          if (adjustedTrip.trackInfoJob.jobFinished.time) {
            adjustedFinishedDate = moment(adjustedTrip.trackInfoJob.jobFinished.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
          }
        }

      }

      let data = [
        trip.tripId ? trip.tripId : '',
        adjustedTrip && adjustedTrip.tripId ? adjustedTrip.tripId : '',
        trip.status ? trip.status : '',

        adjustedTrip && adjustedTrip.status ? adjustedTrip.status : '',
        trip.paymentStatus ? trip.paymentStatus : '',
        trip.changeReason ? trip.changeReason : ' ',
        cancelledDate,
        trip.isWillCallActivated ? 'active' : ' ',
        trip.willCallActivationTime ? moment(trip.willCallActivationTime).tz(timezone).format("MMM DD, YYYY : HH:mm") : '',

        trip.priorityClient && trip.priorityClient.displayName ? trip.priorityClient.displayName : ' ',
        trip.priorityClient && trip.priorityClient.contactNumber ? trip.priorityClient.contactNumber : ' ',
        trip.priorityClient && trip.priorityClient.cellPhone ? trip.priorityClient.cellPhone : ' ',
        trip.priorityClient && trip.priorityClient.clientId ? trip.priorityClient.clientId : ' ',
        trip.priorityClient && trip.priorityClient.dob ? moment(trip.priorityClient.dob).format("MMM DD, YYYY") : '',
        trip.priorityClient && trip.priorityClient.weight ? trip.priorityClient.weight : ' ',

        trip.jobOriginAddress ? trip.jobOriginAddress : ' ',
        adjustedTrip && adjustedTrip.jobOriginAddress ? adjustedTrip.jobOriginAddress : ' ',
        trip.scheduleTime ? moment(trip.scheduleTime).tz(timezone).format("MMM DD, YYYY : HH:mm") : '',
        adjustedTrip && adjustedTrip.scheduleTime ? moment(adjustedTrip.scheduleTime).tz(timezone).format("MMM DD, YYYY : HH:mm") : '',

        trip.cityOrg ? trip.cityOrg : '',
        adjustedTrip && adjustedTrip.cityOrg ? adjustedTrip.cityOrg : '',

        trip.stateOrg ? trip.stateOrg : '',
        adjustedTrip && adjustedTrip.stateOrg ? adjustedTrip.stateOrg : '',

        trip.zipCodeOrg ? trip.zipCodeOrg : '',
        adjustedTrip && adjustedTrip.zipCodeOrg ? adjustedTrip.zipCodeOrg : '',

        trip.jobDestinationAddress ? trip.jobDestinationAddress : '',
        adjustedTrip && adjustedTrip.jobDestinationAddress ? adjustedTrip.jobDestinationAddress : '',
        trip.appointmentTime ? moment(trip.appointmentTime).tz(timezone).format("MMM DD, YYYY : HH:mm") : '',
        adjustedTrip && adjustedTrip.appointmentTime ? moment(adjustedTrip.appointmentTime).tz(timezone).format("MMM DD, YYYY : HH:mm") : '',


        trip.cityDest? trip.cityDest: '',
        adjustedTrip && adjustedTrip.cityDest? adjustedTrip.cityDest: '',

        trip.stateDest? trip.stateDest: '',
        adjustedTrip && adjustedTrip.stateDest? adjustedTrip.stateDest: '',

        trip.zipCodeDest? trip.zipCodeDest: '',
        adjustedTrip && adjustedTrip.zipCodeDest? adjustedTrip.zipCodeDest: '',
        
        trip.milage ? trip.milage : ' ',
        adjustedTrip && adjustedTrip.milage ? adjustedTrip.milage : ' ',

        trip.cooperate && preCooperates[trip.cooperate] ? preCooperates[trip.cooperate].displayName : ' ',
        adjustedTrip && adjustedTrip.cooperate && preCooperates[adjustedTrip.cooperate] ? preCooperates[adjustedTrip.cooperate].displayName : '',

        trip.payorId && prePayorsList[trip.payorId] ? prePayorsList[trip.payorId].name : ' ',

        trip.driver && preDrivers[trip.driver] ? preDrivers[trip.driver].displayName : '',
        adjustedTrip && adjustedTrip.driver && preDrivers[adjustedTrip.driver] ? preDrivers[adjustedTrip.driver].displayName : '',
        // Cost Center
        trip.driver && preDrivers[trip.driver] ? preDrivers[trip.driver].costCenter : '',

        trip.fleet && preFleet[trip.fleet] ? `${preFleet[trip.fleet].setiDecall} - ${preFleet[trip.fleet].driverCarModel} - ${preFleet[trip.fleet].driverCarNumber}` : '',
        adjustedTrip && adjustedTrip.fleet && preFleet[adjustedTrip.fleet] ? `${preFleet[adjustedTrip.fleet].setiDecall} - ${preFleet[adjustedTrip.fleet].driverCarModel} - ${preFleet[adjustedTrip.fleet].driverCarNumber}` : '',

        trip.spaceType && preSpaceTypes[trip.spaceType] ? preSpaceTypes[trip.spaceType].title : ' ',
        adjustedTrip && preSpaceTypes[adjustedTrip.spaceType] ? preSpaceTypes[adjustedTrip.spaceType].title : ' ',

        trip.ipa ? trip.ipa : ' ',
        adjustedTrip && adjustedTrip.ipa ? adjustedTrip.ipa : ' ',

        trip.couponCode ? 'Coupon' : 'Cash',
        trip.couponCode ? trip.couponCode : ' ',
        trip.authorizationNumber ? trip.authorizationNumber : ' ',
        adjustedTrip && adjustedTrip.authorizationNumber ? adjustedTrip.authorizationNumber : ' ',

        // Onway
        acceptedDate ? acceptedDate : ' ',
        adjustedAcceptedDate ? adjustedAcceptedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobAccepted && trip.job.trackInfoJob.jobAccepted.time ? [trip.job.trackInfoJob.jobAccepted.coords[0], trip.job.trackInfoJob.jobAccepted.coords[1]].toString() : ' ',

        // Onscene
        arrivedDate ? arrivedDate : ' ',
        adjustedArrivedDate ? adjustedArrivedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobArrived && trip.job.trackInfoJob.jobArrived.time ? [trip.job.trackInfoJob.jobArrived.coords[0], trip.job.trackInfoJob.jobArrived.coords[1]].toString() : ' ',

        // Member Onboard
        startedDate ? startedDate : '',
        adjustedStartedDate ? adjustedStartedDate : '',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobStarted && trip.job.trackInfoJob.jobStarted.time ? [trip.job.trackInfoJob.jobStarted.coords[0], trip.job.trackInfoJob.jobStarted.coords[1]].toString() : ' ',

        // Completed
        completedDate ? completedDate : ' ',
        adjustedCompletedDate ? adjustedCompletedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobCompleted && trip.job.trackInfoJob.jobCompleted.time ? [trip.job.trackInfoJob.jobCompleted.coords[0], trip.job.trackInfoJob.jobCompleted.coords[1]].toString() : ' ',

        // Finished
        finishedDate ? finishedDate : ' ',
        adjustedFinishedDate ? adjustedFinishedDate : ' ',
        trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobFinished && trip.job.trackInfoJob.jobFinished.time ? [trip.job.trackInfoJob.jobFinished.coords[0], trip.job.trackInfoJob.jobFinished.coords[1]].toString() : " ",

        trip.preSpecialRate ? trip.preSpecialRate : '',
        adjustedTrip && adjustedTrip.preSpecialRate ? adjustedTrip.preSpecialRate : '',
        adjustedTrip && adjustedTrip.preSpecialRate ? adjustedTrip.preSpecialRate : trip.preSpecialRate,
        totalClaims ? totalClaims : ' ',
        calculateClaimAmount(adjustedTrip),
        trip.jobfareformula && trip.jobfareformula.baseFare && trip.jobfareformula.baseFare.fare ? trip.jobfareformula.baseFare.fare : '',
        adjustedTrip && adjustedTrip.baseFare ? adjustedTrip.baseFare : '',

        trip.jobfareformula && trip.jobfareformula.baseFareCode ? trip.jobfareformula.baseFareCode : '',
        adjustedTrip && adjustedTrip.baseFareCode ? adjustedTrip.baseFareCode : '',

        trip.jobfareformula && trip.jobfareformula.perMile ? trip.jobfareformula.perMile : '',
        adjustedTrip && adjustedTrip.perMile ? adjustedTrip.perMile : '',

        trip.jobfareformula && trip.jobfareformula.perMileCode ? trip.jobfareformula.perMileCode : '',
        adjustedTrip && adjustedTrip.perMileCode ? adjustedTrip.perMileCode : '',

        trip.puModifier ? trip.puModifier : '',
        adjustedTrip && adjustedTrip.puModifier ? adjustedTrip.puModifier : '',
        trip.doModifier ? trip.doModifier : '',
        adjustedTrip && adjustedTrip.doModifier ? adjustedTrip.doModifier : '',

        trip.primaryDiagnosis ? trip.primaryDiagnosis : '',
        adjustedTrip && adjustedTrip.primaryDiagnosis ? adjustedTrip.primaryDiagnosis : '',

        trip.job && trip.job.odometerBegin ? trip.job.odometerBegin : ' ',
        adjustedTrip && adjustedTrip.odometerBegin ? adjustedTrip.odometerBegin : ' ',
        trip.job && trip.job.odometerStart ? trip.job.odometerStart : ' ',
        adjustedTrip && adjustedTrip.odometerStart ? adjustedTrip.odometerStart : ' ',
        trip.job && trip.job.odometerStop ? trip.job.odometerStop : ' ',
        adjustedTrip && adjustedTrip.odometerStop ? adjustedTrip.odometerStop : ' ',

        trip.trackId ? trip.trackId : ' ',
        trip.rawId ? trip.rawId : ' ',
        trip.createdAt ? moment(trip.createdAt).tz(timezone).format("MMM DD, YYYY : HH:mm") : '',

        trip.companyNote ? trip.companyNote : ' ',
        trip.billerNote ? trip.billerNote : ' ',
        trip.dispatchNoteTwo ? trip.dispatchNoteTwo : ' ',

        preServiceAreas[trip.serviceArea] ? preServiceAreas[trip.serviceArea].name : ' ',
        preLevelOfServices && preLevelOfServices[trip.los] ? preLevelOfServices[trip.los].title : ' ',

        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMiles ? trip.job.additionalInfoJob.surchargeMiles : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMinutes ? trip.job.additionalInfoJob.surchargeMinutes : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobWaitTime ? trip.job.additionalInfoJob.jobWaitTime : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.totalMiles ? trip.job.additionalInfoJob.totalMiles : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobMinutes ? trip.job.additionalInfoJob.jobMinutes : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobTotalMiles ? trip.job.additionalInfoJob.jobTotalMiles.toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.jobTotalTime ? trip.job.additionalInfoJob.jobTotalTime.toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMiles && trip.job.additionalInfoJob.jobTotalMiles ? (trip.job.additionalInfoJob.jobTotalMiles + trip.job.additionalInfoJob.surchargeMiles).toFixed(2) : ' ',
        trip.job && trip.job.additionalInfoJob && trip.job.additionalInfoJob.surchargeMinutes && trip.job.additionalInfoJob.jobTotalTime ? (trip.job.additionalInfoJob.jobTotalTime + trip.job.additionalInfoJob.surchargeMinutes).toFixed(2) : ' ',
        totalAddonFare,
        adjustmentAddonFare,
        isBeforeScheduleTime ? 'Yes': 'No',
        trip.tripReason && trip.tripReason.length ? trip.tripReason.toString() : ' ',
        trip.actualAppointmentTime && trip.actualAppointmentTime.length ? moment(trip.actualAppointmentTime).tz(timezone).format("MMM DD, YYYY : HH:mm"): ' ',
        trip.cancelReasonNote && trip.cancelReasonNote.length ? trip.cancelReasonNote: ' ',
        trip.job && trip.job.signatureImage ? trip.job.signatureImage : ' ',
        trip.createdBy ? trip.createdBy : ' ',
        trip.updatedBy ? trip.updatedBy : ' ',
      ]
      table.push(data)
    });

    exportToCsv(`raw-report-${moment(date[0]).tz(timezone).format("MM-DD-YYYY")}-${moment(date[1]).tz(timezone).format("MM-DD-YYYY")}.csv`, table);
  }

  driverMonitoringReport(trips, date, timezone) {
    let data;
    let actualPickup, scheduleTime, appointmentTime, actualDropOff, pickupDuration, dropOffDuration;
    let status;
    let dropOffStatus


    const table = [
      [
        "Date",
        "Driver",
        'Patient',
        'Req Pickup',
        'Pick up Arrive',
        'Status(PU)',
        'Duration',
        'Appointment',
        'Dropoff Arrive',
        'Status (Appt)',
        'Duration',
        'Status',
        'Onscene Late Reason',
        'Dropoff Late Reason',
        'Comments'
      ]];
    trips.forEach(trip => {
      if (trip.job) {
        if (trip.scheduleTime) {
          scheduleTime = moment(trip.scheduleTime).tz(timezone).format("HH:mm a");
        }
        if (trip.appointmentTime) {
          appointmentTime = moment(trip.appointmentTime).tz(timezone).format("HH:mm a");
        }
        if (trip.job.trackInfoJob) {
          if (trip.job.trackInfoJob.jobArrived) {
            if (trip.job.trackInfoJob.jobArrived.time) {
              actualPickup = moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("HH:mm a");
              pickupDuration = moment(trip.scheduleTime).diff(moment(trip.job.trackInfoJob.jobArrived.time));
              pickupDuration = (pickupDuration / 60000).toFixed(0);

              const isEarly = moment(trip.scheduleTime).isAfter(moment(trip.job.trackInfoJob.jobArrived.time));
              const diff = pickupDuration
              if (isEarly) {
                if (diff <= 15) {
                  status = "On Time";
                } else {
                  status = "Early";
                }
              } else {
                if (Math.abs(diff) <= 15) {
                  status = "On Time";
                } else {
                  status = "Late";
                }
              }
            }


          }
          if (trip.job.trackInfoJob.jobCompleted) {
            if (trip.job.trackInfoJob.jobCompleted.time) {
              actualDropOff = moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("HH:mm a");
              dropOffDuration = moment(trip.appointmentTime).diff(moment(trip.job.trackInfoJob.jobCompleted.time))
              dropOffDuration = (dropOffDuration / 60000).toFixed(0)
              const isLate = moment(trip.appointmentTime).isAfter(moment(trip.job.trackInfoJob.jobCompleted.time));
              const diff = dropOffDuration
              if (isLate) {
                if (diff <= 15) {
                  dropOffStatus = "On Time";
                } else {
                  dropOffStatus = "Early";
                }
              } else {
                if (Math.abs(diff) <= 15) {
                  dropOffStatus = "On Time";
                } else {
                  dropOffStatus = "Late";
                }
              }


            }
          }

        }
      }




      data = [
        moment(trip.scheduleTime).tz(timezone).format("MM/DD/YYYY"),
        trip.driver ? trip.driver.displayName : ' ',
        trip.priorityClient ? trip.priorityClient.displayName : ' ',
        scheduleTime ? scheduleTime : ' ',
        actualPickup ? actualPickup : ' ',
        status ? status : ' ',
        pickupDuration ? pickupDuration : ' ',
        appointmentTime ? appointmentTime : ' ',
        actualDropOff ? actualDropOff : ' ',
        dropOffStatus ? dropOffStatus : ' ',
        dropOffDuration ? dropOffDuration : ' ',
        trip.status,
        trip.onsceneLateReason ? trip.onsceneLateReason : ' ',
        trip.dropOffLateReason ? trip.dropOffLateReason : ' ',
        trip.cancelReason ? trip.cancelReason : ' '
      ]
      table.push(data)
    });


    exportToCsv(`on-scene-report-${moment(date[0]).tz(timezone).format("MM/DD/YYYY") + "-" + moment(date[1]).tz(timezone).format("MM/DD/YYYY")}.csv`, table);
  }


  viewHourFormat(milli) {
    let duration = moment.duration(milli, 'milliseconds');
    return `${Math.trunc(duration.asHours())}hr ${duration.minutes()}mins`;
  }


  // outbounding messages
  downloadOutBoundReport(data, date, timezone) {
    const table = [
      [
        "Message",
        "From",
        "To	",
        "Error",
        "Status",
        "Sent Date",
        "Created Date",


      ]];
    data.forEach(message => {
      let data = [
        message.body,
        message.from,
        message.to,
        message.errorMessage ? message.errorMessage : ' ',
        message.status,
        moment(message.dateSent).tz(timezone).format("YYYY/MM/DD"),
        moment(message.dateCreated).tz(timezone).format("YYYY/MM/DD"),

      ]

      table.push(data)
    });

    exportToCsv(`out-bound-report-${moment(date[0]).tz(timezone).format("MM/DD/YYYY") + "-" + moment(date[1]).tz(timezone).format("MM/DD/YYYY")}.csv`, table);
  }


  downloadCTCInvoice(data, preFleet, user, timeZone) {

    const table = [
      [
        "Vendor Name",
        "Vendor Tax ID",
        "CTC Trip ID #	",
        "Date of Service",
        "Member Last Name",
        "Member First Name",
        "Pick Up Address",
        "Drop Off Address",
        "Requested Arrival Time",
        "Appointment Time",
        "Actual Pickup Arrival Date",
        "Actual Pickup Arrival Time",
        "Actual Drop off Arrival Date",
        "Actual Drop off Arrival Time",
        "Level of Service",
        "Driver Name",
        "Driver License Number",
        "Vehicle VIN",
        "Trip Status",
        "Miles",
        "Wait Time Minutes",
        "Oxygen Provided",
        "Total Cost",
        "Comment",


      ]];
    data.forEach(trip => {
      let data = [
        // Vendor Name
        user.billingName ? user.billingName : '',
        //Vendor Tax ID,
        user.taxId ? user.taxId : '',
        //CTC Trip ID #,
        trip.tripId,
        //Date of Service,
        moment(trip.scheduleTime).tz(timeZone).format('MM/DD/YYYY'),
        //Member First Name,
        trip.priorityClient ? trip.priorityClient.displayName.split(' ')[1] : '',
        //Member Last Name,
        trip.priorityClient ? trip.priorityClient.displayName.split(' ')[0] : '',
        //Pick Up Address,
        trip.jobOriginAddress,
        //Drop Off Address,
        trip.jobDestinationAddress,
        //Requested Arrival Time,
        moment(trip.scheduleTime).tz(timeZone).format('HHmm'),
        //Appointment Time,
        moment(trip.appointmentTime).tz(timeZone).format('HHmm'),
        //Actual Pickup Arrival Date,
        moment(trip.trackInfoJob.jobArrived.time).tz(timeZone).format('MM/DD/YYYY'),
        //Actual Pickup Arrival Time,
        moment(trip.trackInfoJob.jobArrived.time).tz(timeZone).format('HHmm'),
        //Actual Drop off Arrival Date,
        moment(trip.trackInfoJob.jobFinished.time).tz(timeZone).format('MM/DD/YYYY'),
        //Actual Drop off Arrival Time,
        moment(trip.trackInfoJob.jobFinished.time).tz(timeZone).format('HHmm'),
        //Level of Service,
        // '',
        preFleet[trip.fleet].losDetails.title,
        //Driver Name,
        trip.driver ? trip.driver.displayName : '',
        //Driver License Number,
        trip.driver ? trip.driver.driverLicenseNumber : '',
        //Vehicle VIN,
        '',
        //Trip Status,
        trip.status,
        //Miles,
        trip.milage,
        //Wait Time Minutes,
        '0',
        //Oxygen Provided,
        'False',
        //Total Cost,
        trip.preSpecialRate,
        //Comment,
        '',

      ]

      table.push(data)
    });

    exportToCsv(`CTC-Invoice-report-${moment().tz(timeZone).format('MM/DD/YYYY')}.csv`, table);
  }

  downloadMoneyForBuckReport(data, date, timezone, source) {
    let type;
    if (source == 'Driver') {
      type = source
    }
    else {
      type = source
    }

    const table = [
      [
        type,
        "Trips",
        "Loaded Miles",
        "Dead Miles",
        "Incentive",
      ]];
    data.forEach(res => {
      let data = [
        res.driver ? res.driver.displayName : ' ',
        res.total,
        (res.loadedMiles).toFixed(2),
        (res.deadMiles).toFixed(2),
        "$" + (res.totalInc).toFixed(2)
      ]

      table.push(data)
    });

    exportToCsv(`miles-for-buck-report-${moment(date[0]).tz(timezone).format("MM/DD/YYYY") + "-" + moment(date[1]).tz(timezone).format("MM/DD/YYYY")}.csv`, table);
  }



  // Vehicle CSV Report
  vehicleCsvReport(equipments, fleetList) {
    const table = [
      [
        "Rig#",
        "Division",
        "Rig Type",
        ...equipments.map(equipment => equipment.title)
      ]];
    fleetList.forEach(fleet => {
      let data = [
        fleet.setiDecall ? fleet.setiDecall : ' ',
        (fleet.losDetails && fleet.losDetails.title) ? fleet.losDetails.title : ' ',
        fleet.driverCarModel ? fleet.driverCarModel : ' ',

      ]
      equipments.forEach(equipment => {
        const hasEquipment = fleet.equipments.includes(equipment._id); // Check if the equipment ID is in the fleet
        data.push(hasEquipment ? 'true' : ''); // Add 'true' or 'false' to the data array
      });

      table.push(data)
    });

    exportToCsv(`Equipment-Planning-report.csv`, table);
  }


  downloadVehicleInspectionReport(inspectionList, vehicle, week, date, timezone) {
    const csvData = [];

    // Header Information
    csvData.push([
      "Vehicle ID",
      "Last Six Digits OF VIN",
      "Make & Model",
      "Odometer Reading",
      "Week Start",
    ]);
    csvData.push([
      vehicle.driverCarNumber || " ", // Ensure no undefined values
      inspectionList[0].vinLastNum || " ",
      inspectionList[0].makeModel || " ",
      inspectionList[0].odmReading || " ",
      moment(week).tz(timezone).format("MM/DD/YYYY"),
    ]);
    csvData.push([]); // Blank row for separation

    // Days of the Week (once at the top)
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    csvData.push(["Days of the Week:", ...daysOfWeek]);
    csvData.push([]); // Blank row for separation

    // Determine the day the inspection was done
    const inspectionDate = moment(inspectionList[0].weekDate).day(); // 0 = Sunday, 6 = Saturday

    // Add inspection data as multiple tables
    const labels = {
      exterior: [
        "Ground under vehicle free of leaked fluids?",
        "Auto body free of new damage?",
        "Clean windows and mirrors?",
        "Windshield wipers/washers appear OK?",
      ],
      tires: [
        "Properly inflated?",
        "Free of visible damage?",
      ],
      hood: [
        "Adequate clean oil?",
        "Hoses appear OK? (e.g., no cracks, leaks)",
        "Belts appear OK? (e.g., no fraying)",
        "Adequate windshield washer fluid?",
      ],
      storage: [
        "Current, valid insurance ID card?",
        "Current, valid vehicle registration?",
        "Biohazard kit?",
        "First-aid kit?",
        "Seatbelt cutter?",
        "Flares or reflective triangles?",
        "Fire extinguisher?",
        "Blanket? (winter only)",
      ],
      interior: [
        "Seat belts?",
        "Seats hazard-free (tears, loose armrests)?",
        "Floor free of hazards?",
        "Clean interior?",
        "Mirrors adjusted properly?",
        "Doors operate from inside and outside?",
        "Door locks?",
        "Gauges? (e.g., oil, fuel, temp.)",
        "Fuel level adequate?",
        "No warning lights (e.g., check brakes) lit?",
        "2-way communication device? (e.g., radio/cell)",
        "Horn",
        "Back-up alarm (if equipped)?",
        "Brakes",
        "Heater, defroster, and AC?",
      ],
      lights: [
        "Each headlight (high & low beam)?",
        "Each tail light and marker light?",
        "Each brake light?",
        "Each turn signal?",
        "Each back-up light?",
        "Hazard lights (front and rear)?",
        "License plate light?",
        "Interior lights?",
      ],
      wheelChairRamp: [
        "Operates through complete cycle?",
        "Properly secured to vehicle?",
        "Proper number of restraints?",
        "Free of physical damage or leaking fluid?",
        "Free of dirt, mud, gravel, salt, etc.?",
      ],
    };

    const categories = [
      { name: "Exterior", data: inspectionList[0].exterior },
      { name: "Tires", data: inspectionList[0].tires },
      { name: "Hood", data: inspectionList[0].hood },
      { name: "Storage", data: inspectionList[0].storage },
      { name: "Interior", data: inspectionList[0].interior },
      { name: "Lights", data: inspectionList[0].lights },
      { name: "Wheelchair Ramp", data: inspectionList[0].wheelChairRamp },
    ];

    categories.forEach((category) => {
      const categoryLabels = labels[category.name.toLowerCase()];
      if (category.data && categoryLabels) {
        csvData.push([category.name]); // Add table title
        csvData.push(["Inspection Item"]); // Add column headers

        categoryLabels.forEach((label, index) => {
          const value = Object.values(category.data)[index];
          const dailyStatus = daysOfWeek.map((_, i) =>
            i === inspectionDate ? (value ? "Yes" : "No") : " "
          );
          csvData.push([label, ...dailyStatus]);
        });

        csvData.push([]); // Blank row for separation
      }
    });

    // Driver Name Section
    if (inspectionList[0].attestation.name) {
      const driverNameRow = daysOfWeek.map((_, i) =>
        i === inspectionDate ? inspectionList[0].attestation.name : " "
      );
      csvData.push(["Driver Name:", ...driverNameRow]);
    } else {
      console.warn("Driver name is missing!");
    }

    // Export to CSV
    const fileName = `Vehicle Inspection Report-${moment(date[0]).tz(timezone).format(
      "MM/DD/YYYY"
    )}-${moment(date[1]).tz(timezone).format("MM/DD/YYYY")}.csv`;
    exportToCsv(fileName, csvData);
  }

  async generateDriverSchedule(data) {
    const { date, timeLines, selectedDriver, timeZone } = data;
    const currentDay = moment(date.startDate).tz(timeZone).day();
    const shift = selectedDriver.shifts.find(item=> item.day === currentDay);
    const table = [
      [
        "Date",
        "Driver Name",
        "Employee Id",
        "Pull out",
        "Pull in",
        "Meal Break out",
        "Meal Break in",
        "Rest Break out",
        "Rest Break in",
        "Pull out (Actual)",
        "Pull in (Actual)",
        "Break Hours",
        "Working Hours",
      ]
    ];

    for (const item of timeLines.jobs) {
      const driverBreaks = await this.driverService.getDriverTimelineById(item._id).toPromise();;
      let mealBreakOut, mealBreakIn, restBreakOut, restBreakIn;
      let totalBreakTime = 0;
      if (driverBreaks.breaks && driverBreaks.breaks.length) {
        driverBreaks.breaks.forEach(breakItem => {
          if (breakItem.duration) {
            totalBreakTime += breakItem.duration;
          }
           if (breakItem.status === "approved") {
              mealBreakOut = breakItem.start;
              mealBreakIn = breakItem.stop;
            }
            if (breakItem.status === "rest") {
              restBreakOut = breakItem.start;
              restBreakIn = breakItem.stop;
            }
        });
      }

      let workingTime = 0;
      if (driverBreaks.checkin && driverBreaks.checkout) {
        const checkinTime = moment(driverBreaks.checkin).valueOf();
        const checkoutTime = moment(driverBreaks.checkout).valueOf();
        workingTime = checkoutTime - checkinTime - totalBreakTime;
      }
      const tableData = [
        moment(item.checkin).tz(timeZone).format("MM/DD/YYYY") + "-" + moment(item.checkout).tz(timeZone).format("MM/DD/YYYY"),
        selectedDriver ? selectedDriver.displayName : "N/A",
        selectedDriver ? selectedDriver.employeeId : "N/A",
        shift.checkin ? shift.checkin : "N/A",
        shift.checkout ? shift.checkout : "N/A",
        mealBreakOut ? moment(mealBreakOut).tz(timeZone).format("HH:mm") : "N/A",
        mealBreakIn ? moment(mealBreakIn).tz(timeZone).format("HH:mm") : "N/A",
        restBreakOut ? moment(restBreakOut).tz(timeZone).format("HH:mm") : "N/A",
        restBreakIn ? moment(restBreakIn).tz(timeZone).format("HH:mm") : "N/A",
        driverBreaks.checkin ? moment(driverBreaks.checkin).tz(timeZone).format("HH:mm") : "N/A",
        driverBreaks.checkout ? moment(driverBreaks.checkout).tz(timeZone).format("HH:mm") : "N/A",
        this.viewHourFormat(totalBreakTime),
        this.viewHourFormat(workingTime),
      ];

      table.push(tableData);
    }

    exportToCsv(`driver-schedule-${moment(date.startDate).tz(timeZone).format("MM/DD/YYYY") + "-" + moment(date.endDate).tz(timeZone).format("MM/DD/YYYY")}.csv`, table);
  }


  async allDriverReport(dateRange, preDrivers, timeZone, loader) {
    const table1 = [
      [
        "Date",
        "Driver Name",
        "Rippling Id",
        "Employee Id",
        "Rig No",
        "Vin",
        "Pull Out",
        "Pull In",
        "Pull Out (OR)",
        "Pull In (OR)",
        "Meal Break Out",
        "Meal Break In",
        "Meal Break Out 2",
        "Meal Break In 2",
        "Rest Break Out",
        "Rest Break In",
        "Pull Out (Actual)",
        "Pull In (Actual)",
        "Break Hours",
        "Working Hours",
      ]
    ];
    const sheets = {};

    let queryString = {
      dates: { "startDate": dateRange[0], "endDate": dateRange[1] }
    };
    const shiftOverridesPayload = {
      startDate: dateRange[0],
      endDate: dateRange[1],
      status: 'active'
    };
    let shiftOverrides = [];
    try {
      shiftOverrides = await this.driverService.getShiftOverridesByDate(shiftOverridesPayload).toPromise();
    } catch (e) {
      console.error("Error fetching shift overrides", e);
    }

    const preShiftOverrides: { [driverId: string]: any[] } = {};
    if (shiftOverrides && shiftOverrides.length) {
      shiftOverrides.forEach(override => {
        const driverId = override.driver && override.driver._id ? override.driver._id : override.driver;
        if (driverId) {
          if (!preShiftOverrides[driverId]) {
            preShiftOverrides[driverId] = [];
          }
          preShiftOverrides[driverId].push(override);
        }
      });
    }

    const driverTimeLines = await this.driverService.getDriverTimelinesReport(queryString).toPromise();
    if(!driverTimeLines.length){
      loader.isLoading = false;
      return;
    }
    for (let item of driverTimeLines) {
      if (item && item._id && preDrivers[item._id.driver]) {

        const driver = preDrivers[item._id.driver];

        if (item.jobs && item.jobs.length) {
          for (let item2 of item.jobs) {
            const driverBreaks = item2;
            let mealBreakOut, mealBreakIn, mealBreakOut2, mealBreakIn2, restBreakOut, restBreakIn;
            let totalBreakTime = 0;

            if (driverBreaks.breaks && driverBreaks.breaks.length) {

              let isFirstBreak = false;
              driverBreaks.breaks.forEach(breakItem => {
                if (breakItem.status === "rest") {
                  restBreakOut = breakItem.start;
                  restBreakIn  = breakItem.stop;
                }

                if (breakItem.status === "approved") {
                  if (isFirstBreak) {
                    mealBreakOut2 = breakItem.start;
                    mealBreakIn2 = breakItem.stop;
                  } else {
                    isFirstBreak = true;
                    mealBreakOut = breakItem.start;
                    mealBreakIn = breakItem.stop;
                  }
                }

                if (breakItem.duration) {
                  totalBreakTime += breakItem.duration;
                }
              });
            }

            let workingTime = 0;
            if (driverBreaks.checkin && driverBreaks.checkout) {
              const checkinTime = moment(driverBreaks.checkin).valueOf();
              const checkoutTime = moment(driverBreaks.checkout).valueOf();
              workingTime = checkoutTime - checkinTime - totalBreakTime;
            }

            let pullOutOR = 'N/A';
            let pullInOR = 'N/A';

            if (item2.checkin && preShiftOverrides[item._id.driver]) {
              const checkinDay = moment(item2.checkin).tz(timeZone).format("YYYY-MM-DD");
              const matchedOverride = preShiftOverrides[item._id.driver].find(override => {
                const overrideDay = moment(override.dateOfService).tz(timeZone).format("YYYY-MM-DD");
                return overrideDay === checkinDay;
              });

              if (matchedOverride && matchedOverride.shift) {
                pullOutOR = matchedOverride.shift.checkin || 'N/A';
                pullInOR = matchedOverride.shift.checkout || 'N/A';
              }
            }

            let row = [
              moment(item2.checkin).tz(timeZone).format("MM/DD/YYYY"),
              driver.displayName,
              driver.ripplingWorkerId,
              driver.employeeId,
              driver.fleet && driver.fleet.setiDecall ? driver.fleet.setiDecall : "N/A",
              driver.fleet && driver.fleet.vin ? driver.fleet.vin : "N/A",
              item2.shift && item2.shift.checkin ? item2.shift.checkin : "N/A",
              item2.shift && item2.shift.checkout ? item2.shift.checkout : "N/A",
              pullOutOR,
              pullInOR,
              mealBreakOut ? moment(mealBreakOut).tz(timeZone).format("HH:mm") : "N/A",
              mealBreakIn ? moment(mealBreakIn).tz(timeZone).format("HH:mm") : "N/A",
              mealBreakOut2 ? moment(mealBreakOut2).tz(timeZone).format("HH:mm") : "N/A",
              mealBreakIn2  ? moment(mealBreakIn2).tz(timeZone).format("HH:mm") : "N/A",
              restBreakOut ? moment(restBreakOut).tz(timeZone).format("HH:mm") : "N/A",
              restBreakIn ? moment(restBreakIn).tz(timeZone).format("HH:mm") : "N/A",
              driverBreaks.checkin ? moment(driverBreaks.checkin).tz(timeZone).format("HH:mm") : "N/A",
              driverBreaks.checkout ? moment(driverBreaks.checkout).tz(timeZone).format("HH:mm") : "N/A",
              this.viewHourFormat(totalBreakTime),
              this.viewHourFormat(workingTime),
            ];
            table1.push(row);
          }
        }
      }
    }
    sheets["drivers-timesheet"] = table1;

    exportToExcel(`drivers-timesheet-${moment(dateRange.startDate).format("MM-DD") + '-to-' + moment(dateRange.endDate).format("MM-DD-YYYY")}.xlsx`, sheets);
    loader.isLoading = false;
  }


  generateOtpReport(data) {
    const {
      trips,
      preDrivers,
      preLevelOfServices,
      preSpaceTypes,
      timeZone,
      isEnabledOneHourException
    } = data;

    const columns = [
      "Trip ID",
      "Member ID",
      "Patient",
      "PU Date",
      "DO Date",
      "PU Time",
      "DO Time",
      "Pickup Address",
      "Dropoff Address",
      "LOS",
      "Driver",
      "Trip Status",
      "Miles",
      "OTP Status",
      "OTP Minutes",
      "1-Hour Violation",
      "1-Hour Exception",
      "Pickup Late Reason",
      "DropOff Late Reason"
    ]
    if (!isEnabledOneHourException) {
      columns.splice(-2);
    }
    const table = [columns];


    for (const trip of trips) {
      const los = preLevelOfServices[trip.los];
      const spaceType = preSpaceTypes[trip.spaceType];
      const driver = preDrivers[trip.driver];

      const row = [
        trip.tripId,
        trip.priorityClient && trip.priorityClient.clientId ? trip.priorityClient.clientId : 'N/A',
        trip.priorityClient && trip.priorityClient.displayName ? trip.priorityClient.displayName : 'N/A',
        trip.scheduleTime ? moment(trip.scheduleTime).tz(timeZone).format("MM/DD/YYYY") : 'N/A',
        trip.appointmentTime ? moment(trip.appointmentTime).tz(timeZone).format("MM/DD/YYYY") : 'N/A',
        trip.scheduleTime ? moment(trip.scheduleTime).tz(timeZone).format("HH:mm") : 'N/A',
        trip.appointmentTime ? moment(trip.appointmentTime).tz(timeZone).format("HH:mm") : 'N/A',
        trip.jobOriginAddress,
        trip.jobDestinationAddress,
        spaceType ? `${spaceType.title}` : 'N/A',
        driver ? driver.displayName : 'N/A',
        this.getTripStatus(trip),
        `${trip.milage} mi`,
        trip.tripType !== 'Normal' ? trip.pickupStatus : trip.dropOffStatus,
        trip.tripType !== 'Normal' ? trip.pickupDelayMinutes : trip.dropOffDelayMinutes,
        trip.onboardDurationMinutes ? `${formatDuration(trip.onboardDurationMinutes)} ${trip.oneHourViolation ? '(Violation)' : ''}` : '',
        trip.isAnHourException ? 'Yes' : '',
        trip.onsceneLateReason,
        trip.dropOffLateReason
      ]
      if (!isEnabledOneHourException) {
        row.splice(-2);
      }
      table.push(row);
    }
    exportToCsv(`trips-report-${moment(data.searchDate).tz(timeZone).format("MM-DD-YYYY")}.csv`, table);
  }

  getTripStatus(trip) {
    if (trip.jobStatus === "pending")
      return "Unassigned"
    if (trip.jobStatus === "arrived")
      return "On Scene"
    if (trip.jobStatus === "started")
      return "Member Onboard"
    if (trip.jobStatus === "onway")
      return "In Route"
    else
      return this.capitalize.transform(trip.jobStatus);
  }

  generateFleetReport(data) {
    const { date, fleetList, preStaffList, preServiceAreas, timezone } = data;
    const table = [
      [
        "Name",
        "Vehicle Type",
        "Rig No.",
        "Driver Name",
        "Driver Email",
        "Operations Manager",
        "Service Area(s)",
        "Model",
        "Capacity",
        "Vin",
        "Tracking No.",
        "Source",
        "Created At",
        "Status",
        "Body Type",
        "Real Odometer",
        "Car Year",
        "Car Color",
        "Fuel Type",
        "Gas Card Number",
        "Limitation",
        "Notes",
        "Dim - Width",
        "Dim - Height",
        "Dim - Length",
        "Dim - Ground Clearance",
        "Dim - Bed Length",
        "Dim - Ramp Width",
        "Owner - Name",
        "Owner - Address",
        "Owner - Latitude",
        "Owner - Longitude",
        "Owner - Phone",
        "Owner - Business",
        "Owner - License No"
      ]
    ];

    fleetList.forEach(fleet => {
      let serviceAreasName = [];
      if (fleet.serviceAreas && fleet.serviceAreas.length) {
        fleet.serviceAreas.forEach(item => {
          if (preServiceAreas[item]) {
            serviceAreasName.push(preServiceAreas[item].name);
          }
        });
      }

      let opManager = "N/A";
      if (fleet.driver && fleet.driver.stationManager && preStaffList && preStaffList[fleet.driver.stationManager]) {
        opManager = preStaffList[fleet.driver.stationManager].displayName;
      }

      let createdAt = fleet.createdAt ? moment.utc(fleet.createdAt).tz(timezone).format("MM/DD/YYYY") : "N/A";

      table.push([
        fleet.driverCarNumber ? fleet.driverCarNumber : "N/A",
        fleet.losDetails ? `${fleet.losDetails.title} (${fleet.spaceTypeDetails ? fleet.spaceTypeDetails.title : ''})` : 'N/A',
        fleet.setiDecall ? fleet.setiDecall : "N/A",
        fleet.driver && fleet.driver.displayName ? fleet.driver.displayName : "N/A",
        fleet.driver && fleet.driver.email ? fleet.driver.email : "N/A",
        opManager,
        serviceAreasName.length ? serviceAreasName.join(", ") : "N/A",
        fleet.driverCarModel ? fleet.driverCarModel : "N/A",
        fleet.capacity ? fleet.capacity : "N/A",
        fleet.vin ? fleet.vin : "N/A",
        fleet.vehicleTrackingNumber ? fleet.vehicleTrackingNumber : "N/A",
        fleet.source ? fleet.source : "N/A",
        createdAt,
        fleet.status ? fleet.status : "N/A",
        fleet.bodyType ? fleet.bodyType : "N/A",
        fleet.realOdometer !== undefined && fleet.realOdometer !== null ? fleet.realOdometer : "N/A",
        fleet.driverCarYear ? fleet.driverCarYear : "N/A",
        fleet.driverCarColor ? fleet.driverCarColor : "N/A",
        fleet.fuelType ? fleet.fuelType : "N/A",
        fleet.gasCardNumber ? fleet.gasCardNumber : "N/A",
        fleet.limitation ? fleet.limitation : "N/A",
        fleet.notes ? fleet.notes : "N/A",
        fleet.dimensions && fleet.dimensions.width ? fleet.dimensions.width : "N/A",
        fleet.dimensions && fleet.dimensions.height ? fleet.dimensions.height : "N/A",
        fleet.dimensions && fleet.dimensions.length ? fleet.dimensions.length : "N/A",
        fleet.dimensions && fleet.dimensions.groundClearance ? fleet.dimensions.groundClearance : "N/A",
        fleet.dimensions && fleet.dimensions.bedLength ? fleet.dimensions.bedLength : "N/A",
        fleet.dimensions && fleet.dimensions.rampWidth ? fleet.dimensions.rampWidth : "N/A",
        fleet.owner && fleet.owner.name ? fleet.owner.name : "N/A",
        fleet.owner && fleet.owner.address ? fleet.owner.address : "N/A",
        fleet.owner && fleet.owner.latitude ? fleet.owner.latitude : "N/A",
        fleet.owner && fleet.owner.longitude ? fleet.owner.longitude : "N/A",
        fleet.owner && fleet.owner.phone ? fleet.owner.phone : "N/A",
        fleet.owner && fleet.owner.business ? fleet.owner.business : "N/A",
        fleet.owner && fleet.owner.licenseNo ? fleet.owner.licenseNo : "N/A"
      ]);
    });

    exportToCsv(`fleet-report-${date}.csv`, table);
  }

   generateDriverCSV(data, preFundingSource, selectedDriver , dateRange) {

    const table = [
      [
        "Date",
        "Driver",
        "Member",
        "Mileage",
        "Amount",
        "Funding Source",
      ]
      ];


      data.forEach((item:any) => {
         let temp = [
        moment(item.scheduleTime).format('MM/DD/YYYY'),
        selectedDriver.displayName,
        item.priorityClient.displayName,
        item.milage,
        item.preSpecialRate,
        preFundingSource[item.cooperate].displayName
         ]
      table.push(temp)
    });
    exportToCsv(`${selectedDriver.displayName}-report-${moment(dateRange[0]).format('MM/DD/YYYY') + '-' + moment(dateRange[1]).format('MM/DD/YYYY')}.csv`, table);
    // this.excelService.setCombinedFirstRowWithFontSize(date, table, `drivers-report-${moment().format("MM-DD-YYYY")}`);
  }
  }







